import React from "react"
import styled from "styled-components"
import fonts from "../../styles/fonts"
import colors from "../../styles/colors"
import ContentContainer from "./Engagement/ContentContainer"
import { renderRichText } from "gatsby-source-contentful/rich-text"

const Background = styled.div`
  background: ${colors.white};
  padding-top: 20px;
  padding-bottom: 96px;

`

const ContentCopy = styled.div`
  ${fonts.helveticaNeueLight};
  font-size: 14px;
  line-height: 26px;
  color: ${colors.textGrey};
  letter-spacing: 0;

  h2 {
    ${fonts.selfModern};
    color: ${colors.black};
    font-size: 24px;
    line-height: 32px;
    padding: 22px 0;
    max-width: 956px;
  }

  h3 {
    ${fonts.helveticaNeueLight};
    font-size: 14px;
    margin-bottom: 4px;
    color: ${colors.textGrey};
    b {
      ${fonts.helveticaNeueCondensedMedium};
    }
  }

  p {
    margin-bottom: 14px;
    a {
      color: ${colors.green};
      text-decoration: none;
    }
    b {
      ${fonts.helveticaNeueCondensedMedium};
    }

    &:last-of-type {
      margin-bottom: 0px;
    }
  }
`

const SeoContent = ({content}) => {
  return (
    <Background>
      <ContentContainer>
        <ContentCopy>
          {renderRichText(content)}
        </ContentCopy>

      </ContentContainer>
    </Background>
  )
}

export default SeoContent

